function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.914,23.308l-15.094,6.52l0,-6.52l15.094,0Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.82,23.308l15.094,-3.389l0,3.389l-15.094,0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.794,9.008l-5.794,4.315l0,-4.315l5.794,0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20,9.008l5.794,-2.242l0,2.242l-5.794,0Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.086,23.308l15.094,6.52l0,-6.52l-15.094,0Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.18,23.308l-15.094,-3.389l0,3.389l15.094,0Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.206,9.008l5.794,4.315l0,-4.315l-5.794,0Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20,9.008l-5.794,-2.242l0,2.242l5.794,0Z"
});

var SvgPenflightlogo = function SvgPenflightlogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 60",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 18.083,
    y: 36.328,
    width: 3.737,
    height: 18.934,
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,53.72l7.205,3.083l-14.41,0l7.205,-3.083Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.783,6.783l11.028,0l0,16.432l-33.093,0l0,-16.432l10.56,0l5.752,2.964l5.753,-2.964Z",
    style: {
      fill: "#4285f4"
    }
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("path", {
    d: "M36.419,20.583l0,-17.803",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.585,21.613l0,-18.833",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.373,2.78l-32.788,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.539,38.397l0,18.823",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.373,38.387l0,18.833",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.585,57.22l32.788,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.208,38.137l-16.046,-7.284",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.208,38.137l-16.046,-7.284",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.765,30.853l-16.047,7.284",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,37.221l0,-25.608",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "3.8px",
      strokeLinecap: "round"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPenflightlogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/penflight logo.5f6c03a0.svg";
export { ForwardRef as ReactComponent };